import RBush from 'rbush';

import { getVisibleTiles } from './getVisibleTiles';
import { IFrecklesRBushItem } from '../../types/freckles';
import { getExtendedTileBBox } from '../tile';

interface IGetExtraTilesToUpdateParams {
  rbushItems: IFrecklesRBushItem[];
  bounds: [YMaps.TCoord, YMaps.TCoord];
  zoom: number;
}

export function getFrecklesPointsTilesToUpdate(params: IGetExtraTilesToUpdateParams): YMaps.TTileNumber[] {
  const { rbushItems, zoom: zoomRaw, bounds } = params;

  const sapling = new RBush();
  sapling.load(rbushItems);

  const zoom = Math.round(zoomRaw);
  const visibleTilesNumbers = getVisibleTiles(bounds, zoom);

  const tilesToUpdate: YMaps.TTileNumber[] = [];
  visibleTilesNumbers.forEach(tileNumber => {
    const extendedTileBox = getExtendedTileBBox({ tileNumber, zoom });

    if (sapling.collides(extendedTileBox)) {
      tilesToUpdate.push(tileNumber);
    }
  });

  return tilesToUpdate;
}
